import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { docPathForPath } from "../../lib/docs/module-map";
import { isDocsPaneOpen, subscribeDocsPane, toggleDocsPane } from "../../lib/docs/pane-state";

// Floating context-aware toggle for the docs pane. Bottom-right of the
// shell. Highlights when the pane is open so the affordance is obvious.
//
// The button is always visible; the pane itself figures out whether the
// current route has a mapped doc and renders a placeholder if not. This
// keeps the toggle position stable no matter where you navigate.
export default function ModuleDocButton() {
  const [pathname] = useLocation();
  const [open, setOpen] = useState(isDocsPaneOpen);

  useEffect(() => subscribeDocsPane(() => setOpen(isDocsPaneOpen())), []);

  const routeHasDoc = docPathForPath(pathname) !== null;

  return (
    <button
      onClick={toggleDocsPane}
      aria-label={open ? "Close docs pane" : "Open docs pane"}
      title={
        open
          ? "Close docs pane"
          : routeHasDoc
            ? "Open module docs"
            : "Open docs pane (no doc mapped for this route)"
      }
      className={`fixed bottom-4 right-4 z-30 p-2.5 rounded-full border shadow-md transition-colors cursor-pointer ${
        open
          ? "bg-indigo-600 border-indigo-500 text-white hover:bg-indigo-700"
          : "bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-700 dark:hover:text-indigo-300"
      }`}
    >
      <span className="text-lg leading-none">📖</span>
    </button>
  );
}
